import * as React from 'react';
import styled from 'styled-components';
import { FieldProps } from '../../core/form';
import { errorRed, labelGrey, newErrorRed } from '../../appComponents/cssConstants';

const FieldDecorator = ({
	name,
	errors,
	label,
	subLabel,
	required,
	children,
	className = '',
	customErrorMessage,
	newDesign = false,
	defaultFormField = true
}: FieldDecoratorProps) => {
	return (
		<FormFieldWrapper className={`${defaultFormField ? 'default-form-field' : ''} ${className}`}>
			{label && (
				<StyledLabel htmlFor={name}>
					{label}
					{required && ' *'}
					{subLabel && <SubLabel>{subLabel}</SubLabel>}
				</StyledLabel>
			)}
			{children}
			{errors && errors[name] && (
				<FieldError $newDesign={newDesign}>{customErrorMessage ?? errors[name].message}</FieldError>
			)}
		</FormFieldWrapper>
	);
};

interface FieldDecoratorProps extends FieldProps {
	children: React.ReactNode;
	className?: string;
	subLabel?: string;
	customErrorMessage?: string;
	newDesign?: boolean;
}

export default FieldDecorator;

const FormFieldWrapper = styled.div`
	display: inline-block;
	width: 100%;
	margin-bottom: 10px;
`;

const StyledLabel = styled.label`
	display: block;
	font-size: 18px;
	line-height: 21px;
	color: ${labelGrey};
	margin: 6px 0;
`;

const SubLabel = styled.em`
	display: block;
	font-size: 16px;
	margin-top: 15px;
	font-weight: normal;
`;

const FieldError = styled.p<{ $newDesign: boolean }>`
	font-size: 10px;
	line-height: 16px;
	color: ${(props) => (props.$newDesign ? newErrorRed : errorRed)};
	margin-top: 5px;
`;
